// Tutto quello che una scheda del browser tiene in memoria **per la persona
// collegata**, e che quindi va buttato via quando la persona cambia.
//
// Nasce da un guasto vero: impersonando un ADMIN che ha diritto di vedere solo
// sé stesso, le pagine Ferie, Saldi, Banca ore e Costo del lavoro mostravano
// tutte e 38 le persone dell'azienda. Il servizio rispondeva correttamente —
// verificato: quell'ADMIN risolve a una persona sola — ma nessuno glielo
// chiedeva più: l'elenco era già in memoria dalla sessione precedente, e le
// pagine lo riusano apposta (`store.utenti.length ? salta : carica`).
//
// Un cambio di identità nella stessa scheda è, per i dati, un cambio di
// sessione: token nuovo, permessi nuovi, elenchi da rifare. Senza questo
// passaggio l'impersonazione mostra i dati di chi impersona, che è esattamente
// il contrario di quello che serve.
//
// Non si azzera quello che appartiene al browser e non alla persona: tema,
// branding e preferenze di layout restano dove sono.

import { useWorkforceStore } from '../stores/workforce.store';
import { usePermessiStore } from '../stores/permessi.store';
import { useNewsStore } from '../stores/news.store';
import { usePbxStore } from '../stores/pbx.store';
import { resetAiStatusCache } from '../hooks/useAiEnabled';
import { clearHelpdeskUserCache } from './helpdesk';
import { clearEffeisbuckUserCache } from './effeisbuck';

export function azzeraDatiDiSessione() {
  resetAiStatusCache();
  clearHelpdeskUserCache();
  clearEffeisbuckUserCache();
  // Ogni store si pulisce da sé: se uno non espone `azzera` viene saltato
  // invece di far fallire il cambio di identità, che deve avvenire comunque.
  for (const store of [useWorkforceStore, usePermessiStore, useNewsStore, usePbxStore]) {
    try {
      const azzera = store.getState().azzera;
      if (typeof azzera === 'function') azzera();
    } catch (err) {
      console.error('[sessione] azzeramento di uno store non riuscito:', err?.message || err);
    }
  }
}
